import React from "react";
import {
    TableContentForLeafCollectionDetailsReport
} from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const fieldColumnNames = this.props.fieldColumnNames;
        const factoryColumnNames = this.props.factoryColumnNames;
        const fullTotalRow = this.props.fullTotalRow;
        const lossExces = this.props.lossExces;

        return (
            <div>
                <h3><center><u>Leaf Collection Details Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                <div>
                    <div className="pl-3 pb-2">
                        <h5>Loss/Excess (Kg): <span class={lossExces > 0 ? "badge badge-success" : "badge badge-danger"}>
                            {lossExces.toFixed(2)}
                        </span>
                        </h5>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="leafCollectionSummaryPdf">
                                <thead>
                                    <tr>
                                    <th rowSpan="2">Index</th>
                                    <th rowSpan="2">Route Code</th>
                                    <th rowSpan="2">Reg Number</th>
                                    <th rowSpan="2">Narration</th>
                                    <th rowSpan="2">Date</th>
                                    <th rowSpan="2">Leaf Type</th>
                                    <th rowSpan="2">Tag Number</th>
                                    <th style={{ textAlign: "center" }} colSpan={2 + fieldColumnNames.length}>Field</th>
                                    <th style={{ textAlign: "center" }} colSpan={2 + factoryColumnNames.length}>Factory</th>
                                    <th rowSpan="2">Variance +/-</th>
                                    </tr>
                                    <tr>
                                        <th>Gross /Kg</th>
                                        {fieldColumnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index}>{x}</th>
                                            )
                                        })}
                                        <th>Net /Kg</th>
                                        <th>Gross /Kg</th>
                                        {factoryColumnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index}>{x}</th>
                                            )
                                        })}
                                        <th>Net /Kg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForLeafCollectionDetailsReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan="6">Total</th>
                                        <th style={{ textAlign: "right" }}>{fullTotalRow.bagCount}</th>
                                        {contentRowNames.map((x, i) => {
                                            var res = fullTotalRow.find(y => y.name === x);

                                            if (res) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                );
                                            } else if (res === undefined && x.includes("_Kg")) {
                                                return (
                                                    <th index={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                );
                                            }

                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}